import Img_sword from '@/assets/image/gea/sword.svg'
import AddressHash from '@/components/AddressHash'
import styles from './index.module.less'
import { ugeaToGea2 } from '@/utils/number'
import useMeNavigate from '@/hooks/useMeNavigate'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import { useGlobalStore } from '@/hoxStore/globalStore'
const GasFee = ({ receivers }: { receivers: any[] }) => {
  const navigete = useMeNavigate()
  const { t } = useTranslation()
  const { curReponsive } = useGlobalStore()
  return (
    <div className={styles.gasFeeWrapper}>
      <div className={styles.gasFeeTitle}>{t('explorer_256')}</div>
      <div className={styles.gasFeeContentList}>
        {receivers.map((item, index) => {
          return (
            <div key={index} className={styles.gasFeeContent}>
              <div
                className={classNames({
                  [styles.gasFeeContentLeft]: true,
                  font_12: curReponsive?.size === 'mobile' ? true : false,
                })}
              >
                <span>GasFee:</span>
                <div>
                  <span className={styles.gasFeeContentLeftValue}>
                    {ugeaToGea2(item.amount).value}
                  </span>
                  <span> {ugeaToGea2(item.amount).sigin}</span>
                </div>
              </div>
              <div className={styles.gasFeeContentLeftIcon}>
                <img src={Img_sword} alt="" />
              </div>
              <div
                className={classNames({
                  [styles.gasFeeContentRight]: true,
                  font_12: curReponsive?.size === 'mobile' ? true : false,
                })}
              >
                <span>{t('explorer_107')}</span>
                <AddressHash
                  data={item.address}
                  copyIcon={'gray'}
                  cutOption={curReponsive?.size === 'mobile' ? true : false}
                  handleJump={() => {
                    navigete(`/accountDetail/${item.address}`)
                  }}
                ></AddressHash>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default GasFee
